<template>
    <template v-if="product.quantity_sold == true">
        <span class="text-danger p-2"> نفذت الكمية </span>
    </template>
    <template v-else>
        <template v-if="type == 'link' ">

            <button class="btn btn-lg btn-primary rounded"
               v-if="!in_cart " @click="addToCart(this.quantity + 1 )">

                {{ $t('Add to cart') }}
                <span class="cart-icon"><i class="fi-rr-shopping-basket"></i></span>
            </button>

            <button class="btn btn-lg btn-outline-danger text-danger rounded"
               v-if="in_cart " @click="addToCart(0 )">
                {{ $t('Remove from cart') }}

                <span class="cart-icon"><i class="fi-rr-shopping-basket"></i></span>
            </button>

        </template>
        <template v-if="type == 'cart-qty-plus-minus' ">

            <div class="cart-qty-plus-minus">
                <input class="cart-plus-minus ps-2" type="text" :value="quantity">
                <div class="ec_cart_qtybtn">
                    <div class="inc ec_qtybtn" @click="addToCart( this.quantity + 1 )">+</div>
                    <div class="dec ec_qtybtn" @click="addToCart( this.quantity - 1 )">-</div>
                </div>
            </div>

        </template>
        <template v-if="type == 'qty-input' ">

            <div class="qty-plus-minus">
                <div class="dec ec_qtybtn" @click="addToCart( this.quantity - 1 )">-</div>
                <input class="qty-input  text-center" type="text" :value="quantity" readonly>
                <div class="inc ec_qtybtn" @click="addToCart(this.quantity + 1 )">+</div>
            </div>

        </template>
        <template v-if="type == 'button-qty-input' ">

            <div class="qty-plus-minus " v-if="in_cart ">
                <div class="dec ec_qtybtn" @click="addToCart( this.quantity - 1 )">-</div>
                <input class="qty-input  text-center" type="text" :value="quantity" readonly>
                <div class="inc ec_qtybtn" @click="addToCart(this.quantity + 1 )">+</div>
            </div>

            <div class="ec-single-cart " v-if="!in_cart " @click="addToCart(this.quantity + 1 )">
                <button class="btn btn-primary">{{ $t('Add to cart') }}</button>
            </div>

            <div class="ec-single-cart " v-if="in_cart " @click="addToCart(0 )">
                <button class="btn btn-primary">{{ $t('Remove from cart') }}</button>
            </div>

        </template>
        <template v-if="type == 'ec-link-btn' ">

            <a class="ec-add-to-cart btn-danger" v-if="in_cart " @click="addToCart(0 )">
                {{ $t('Remove from cart') }}
            </a>
            <a class="ec-add-to-cart btn-success" v-if="!in_cart " @click="addToCart(this.quantity + 1 )">
                {{ $t('Add to cart') }}
            </a>


        </template>
        <template v-if="type == 'outline-link' ">

            <div class="ec-link-btn">
                <button class=" ec-add-to-cart text-danger" v-if="in_cart " @click="addToCart(0 )">
                    {{ $t('Remove from cart') }}
                </button>
                <button class=" ec-add-to-cart text-success" v-if="!in_cart " @click="addToCart(this.quantity + 1 )">
                    {{ $t('Add to cart') }}
                </button>
            </div>

        </template>
        <template v-if="type == 'small' ">

            <button class="btn btn-lg btn-primary"
                    v-if="!in_cart " @click="addToCart(this.quantity + 1 )">
                {{ $t('Add')}}

                <span class="cart-icon"><i class="fi-rr-shopping-basket"></i></span>
            </button>

            <button class="btn btn-lg btn-outline-danger text-danger"
                    v-if="in_cart " @click="addToCart(0 )">
                {{ $t('Remove')}}

                <span class="cart-icon"><i class="fi-rr-shopping-basket"></i></span>
            </button>


        </template>
    </template>
</template>

<script>

import store from './store'; // Replace with the actual path to your store

export default {
    inject: ['auth'],
    props: ['product', 'type','cart'],
    data() {
        return {
            quantity: this.product?.cart?.quantity ?? this.cart?.quantity ?? 0,
            // localInCart: this.product.cart !== null,
        };
    },
    computed: {
        in_cart() {
            return store.getters.cartItems.some(item => {
                return item.id === ( this.product?.cart?.id ?? this.cart?.id );
            }) || this.quantity > 0;
        }
    },
    methods: {
        async addToCart(_quantity ) {

            // this.auth.check().then((response) => {
            //     if(response === false){
            //         this.$router.push({ name: 'login', params: { lang : this.$i18n.locale } });
            //     }
            // });
            console.log(this.auth.isLoggedIn());
            console.log(this.auth);
            if(this.auth.isLoggedIn() === false){
                // TODO: المفروض فتح نافذة الدخول
                // this.$router.push({ name: 'login', params: { lang : this.$i18n.locale } });

                window.scrollTo(0,0);
                return null;
            }

            if(_quantity >= 0){
                this.quantity = _quantity;
            }

            if( this.quantity >= 1){
                const response = await await store.dispatch('addToCart',
                    { product: this.product, quantity: _quantity } );
                this.product.cart = response.data;
            }else{
                this.removeFromCart();
            }
        },
        async removeFromCart() {
            await store.dispatch('removeFromCart', this.product?.cart?.id ?? this.cart?.id);
        }
    },
    async created() {
        // if (this.product.cart !== null) {
        //     await store.dispatch('autoAddToCart', this.product);
        // }
    },
}
</script>
